
import Vue from 'vue';
import Component from 'vue-class-component';
import EmailHtmlFrame from '@/components/helpdesk/EmailHtmlFrame.vue';
import BrokenImagesNotice from '@/components/helpdesk/BrokenImagesNotice.vue';
import {Prop, Watch} from 'vue-property-decorator';
import {IEmailSignature} from '@/store/modules/helpdeskEmailSignaturesModule';

@Component({name: 'SignatureSelector', components: {EmailHtmlFrame, BrokenImagesNotice}})
export default class SignatureSelector extends Vue {
  @Prop({default: ''}) value!: string;
  @Prop({default: ''}) userEmail!: string;

  selectedId: number | null = null;
  loading = false;

  get signatures(): IEmailSignature[] {
    return this.$store.getters['helpdeskEmailSignaturesModule/signatures'] || [];
  }

  get selectedSignature(): IEmailSignature | null {
    if (!this.selectedId) return null;
    return this.signatures.find(s => s.id === this.selectedId) || null;
  }

  created() {
    this.loading = true;
    this.$store.dispatch('helpdeskEmailSignaturesModule/fetchAll')
      .then(() => {
        this.loading = false;
        this.autoSelect();
      })
      .catch(() => { this.loading = false; });
  }

  @Watch('userEmail')
  onUserEmailChanged() {
    this.autoSelect();
  }

  private autoSelect() {
    if (!this.userEmail) return;
    const match = this.signatures.find(s => s.user_email === this.userEmail);
    if (match) {
      this.selectedId = match.id;
      this.$emit('input', match.body);
    }
  }

  onSelect(id: number | null) {
    if (!id) {
      this.$emit('input', '');
      return;
    }
    const sig = this.signatures.find(s => s.id === id);
    this.$emit('input', sig ? sig.body : '');
  }
}
